import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json";

const Footer = lazy(() => import("./components/Footerupdated/Footer.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));



function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();
  const isProduction = process.env.NODE_ENV === 'production';
  const appVersion = appversion.version;

  useEffect(() => {
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_MARCHEXCLUSIVE_CDN_URL)
        .then(response => {          
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();
  }, []);

  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (

    <CacheBuster
    currentVersion={appVersion}
    isEnabled={true} //If false, the library is disabled.
    isVerboseMode={false} //If true, the library writes verbose logs to console.
    // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
    metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
  >
    <div className="bodyContainer"> 
      <Header links={links} fetchpriority="high"/>      
      {bannerData ?
      <>      
      <Body links={links} bannerData={bannerData} timerData={timerData} formData={formData} fetchpriority="high" />            
        
      {/* <Suspense fallback={<div />}>
      <LogoSection fetchpriority="low" />
      </Suspense> */}
      <Suspense fallback={<div />}>
      {highlightsData ?
        <Highlights highlightsData={highlightsData} />
        : ""}
      </Suspense> 
      <Suspense fallback={<div />}>
      {propertyData ?
        <Proprty propertyData={propertyData} />
        : ""}
      </Suspense> 
      <Suspense fallback={<div />}>   
      <Morganlogos links={links}/>  
      </Suspense> 
      <Suspense fallback={<div />}>   
      <Whysunwest links={links}/>  
      </Suspense>  
      <Suspense fallback={<div />}>
      <Footer />
      </Suspense>         
      </>
         : ""}  
    </div>
    </CacheBuster>
  );
}

export default App;
